import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { queryClient } from './api/query-client';
import { TranslationsProvider } from '@/i18n/TranslationsProvider';
import { router } from './router';
import { ThemeProvider } from './theme';
import './i18n';
import './styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element in index.html');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TranslationsProvider>
        <ThemeProvider>
          <RouterProvider router={router} />
        </ThemeProvider>
      </TranslationsProvider>
    </QueryClientProvider>
  </StrictMode>,
);
